import { createModuleDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';

export const versionDefinitionV0 = createModuleDefinitionVersion({
  label: 'jsw-interactive-board',
  description:
    'This library contains an interactive board for the JSW product. ',
  status: 'active',
  channels: ['web', 'mobile', 'desktop'],
  fieldDefinitions: [
    {
      name: 'toDo',
      type: 'string',
      label: 'To Do Column',
      defaultValue: 'To Do',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'inProgress',
      type: 'string',
      label: 'In Progress Column',
      defaultValue: 'In Progress',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'done',
      type: 'string',
      label: 'Done Column',
      defaultValue: 'Done',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'create',
      type: 'string',
      label: 'Create button',
      defaultValue: 'Create',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'restartDemo',
      type: 'string',
      label: 'Restart demo button',
      defaultValue: 'Restart demo',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'avatarGroupAriaLabel',
      type: 'string',
      label: 'aria-label for avatarGroup image',
      defaultValue: 'Collection of user avatars showing team members',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalHeader',
      type: 'string',
      label: 'Create issue',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput1Label',
      type: 'string',
      label: 'Project',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput2Label',
      type: 'string',
      label: 'Issue type',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput3Label',
      type: 'string',
      label: 'Summary',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput3Placeholder',
      type: 'string',
      label: 'Ex: Create a requirements doc',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput4Label',
      type: 'string',
      label: 'Issue description',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput4Placeholder',
      type: 'string',
      label:
        'Add notes: \nWrite details here like receive final prototypes from design. \n \nAdd tasks: \nWrite necessary tasks to complete your project here.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput5Label',
      type: 'string',
      label: 'Priority',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput6Label',
      type: 'string',
      label: 'Epic link',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput7Label',
      type: 'string',
      label: 'Assignee',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalInput8Label',
      type: 'string',
      label: 'Due date',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalProjectOption1',
      type: 'string',
      label: 'Team Rocket',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalProjectAssetLabel1',
      type: 'string',
      label: 'project',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeOption1',
      type: 'string',
      label: 'Task',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeAssetLabel1',
      type: 'string',
      label: 'task',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeOption2',
      type: 'string',
      label: 'Story',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeAssetLabel2',
      type: 'string',
      label: 'story',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeOption3',
      type: 'string',
      label: 'Bug',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalIssueTypeAssetLabel3',
      type: 'string',
      label: 'bug',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeOption1',
      type: 'string',
      label: 'Alvin',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeAssetLabel1',
      type: 'string',
      label: 'alvin',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeOption2',
      type: 'string',
      label: 'Jane',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeAssetLabel2',
      type: 'string',
      label: 'jane',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeOption3',
      type: 'string',
      label: 'Blake',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalAssigneeAssetLabel3',
      type: 'string',
      label: 'blake',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityOption1',
      type: 'string',
      label: 'High',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityAssetLabel1',
      type: 'string',
      label: 'priority-high',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityOption2',
      type: 'string',
      label: 'Critical',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityAssetLabel2',
      type: 'string',
      label: 'priority-critical',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityOption3',
      type: 'string',
      label: 'Blocker',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityAssetLabel3',
      type: 'string',
      label: 'priority-blocker',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityOption4',
      type: 'string',
      label: 'Minor',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalPriorityAssetLabel4',
      type: 'string',
      label: 'priority-minor',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption1',
      type: 'string',
      label: 'Features',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption1Description',
      type: 'string',
      label: 'APP-153',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkAssetLabel1',
      type: 'string',
      i18n: true,
      label: 'epic-link-features',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption2',
      type: 'string',
      label: 'Analytics',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption2Description',
      type: 'string',
      label: 'APP-154',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkAssetLabel2',
      type: 'string',
      label: 'epic-link-analytics',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption3',
      type: 'string',
      label: 'Payments',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkOption3Description',
      type: 'string',
      label: 'APP-155',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalEpicLinkAssetLabel3',
      type: 'string',
      label: 'epic-link-payments',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalSubmitBtn',
      type: 'string',
      label: 'Create',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightInitialCreateButtonHeading',
      type: 'string',
      label: 'spotlight initial create button heading',
      defaultValue: "Let's set up your board",
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightInitialCreateButtonDescription',
      type: 'string',
      label: 'spotlight initial create button description',
      defaultValue:
        'Kanban boards are great for project management. Select create to start tracking work that your team would like to do.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'createIssueModalCloseBtn',
      type: 'string',
      label: 'Close modal',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectIssueHeading',
      type: 'string',
      label: 'spotlight select issue heading',
      defaultValue: 'Create an issue',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectIssueDescription',
      type: 'string',
      label: 'spotlight select issue description',
      defaultValue:
        'Issues are used to track work in Jira. Tasks, stories, and bugs are different types of issues. Select what type of issue you’d like to create.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSummaryHeading',
      type: 'string',
      label: 'spotlight add summary heading',
      defaultValue: 'Tell us about your work',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSummaryDescription',
      type: 'string',
      label: 'spotlight add summary description',
      defaultValue:
        'Summarize your to-do in a few words. It can be anything, like complete mobile app designs or developing a new feature.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightAddDescriptionHeading',
      type: 'string',
      label: 'spotlight add description heading',
      defaultValue: 'Provide useful details',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightAddDescriptionDescription',
      type: 'string',
      label: 'spotlight add description description',
      defaultValue:
        'Add any important information about the work that’s needed to move it forward.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightMoveIssueHeading',
      type: 'string',
      label: 'Heading for final create issue spotlight',
      defaultValue: 'Move your task to the board',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectPriorityHeading',
      type: 'string',
      label: 'spotlight select priority heading',
      defaultValue: 'Prioritize your task',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightMoveIssueDescription',
      type: 'string',
      label: 'Description text for final create issue spotlight',
      defaultValue: `Now that you’ve added all the info to your task. Select create to see your work on the “To-do” list.`,
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectPriorityDescription',
      type: 'string',
      label: 'spotlight select priority description',
      defaultValue:
        'Choose the importance of a task to change how it appears on the board. Select a level of priority to identify this task at a glance.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectEpicLinkHeading',
      type: 'string',
      label: 'spotlight select epic link heading',
      defaultValue: 'Connect work to larger projects',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'spotlightSelectEpicLinkDescription',
      type: 'string',
      label: 'spotlight select epic link description',
      defaultValue:
        'You can connect this issue to longer term projects. This will help your team plan accurately.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'todoStaticLabel',
      type: 'string',
      label: 'static todo card summary',
      defaultValue: 'Design AI shopping suggestions for homepage',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'inProgStaticLabel1',
      type: 'string',
      label: 'static in progress card1 summary',
      defaultValue: 'Create AI-generated shopping suggestions for homepage',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'inProgStaticLabel2',
      type: 'string',
      label: 'static in progress card2 summary',
      defaultValue: 'Add advanced analytics tracking events',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'doneStaticLabel1',
      type: 'string',
      label: 'static in done card1 summary',
      defaultValue: 'Improve payment checkout time on mobile',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'doneStaticLabel2',
      type: 'string',
      label: 'static in done card2 summary',
      defaultValue: 'Define requirements to use new AI integrations',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'successModalHeading',
      type: 'string',
      defaultValue: 'Congratulations on your first board !',
      label: 'Success modal heading',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'successModalDescription',
      type: 'string',
      defaultValue:
        'You’ve taken the first step towards streamlined collaboration and task tracking. Get started for free using the project management template in Jira.',
      label: 'Success modal description',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'successModalCtaButton',
      type: 'string',
      defaultValue: 'Get it free',
      label: 'Success modal CTA button text',
      i18n: true,
      validations: {
        isRequired: true
      }
    }
  ]
});
